<div class="container">
  <a class="logo-container" routerLink="/" gnxRtl>
    <img src="/assets/svg/franklin-dark-bg.svg" />
  </a>
  @if (showVariantSearchBar()) {
    <gnx-search-bar />
  }
  @if (showAnalysisSearchBar()) {
    <gnx-analysis-search-bar />
  }
  <div class="apps-nav-container" gnxRtl>
    @for (app of MINI_APPS; track app) {
      <a class="app-link" [routerLink]="app.path" [class.active]="app.app === activeMiniApp()">
        <img [src]="app.icon" gnxRtl /><span>{{ app.label | i18n }}</span>
      </a>
    }
  </div>
  @if (showVariantSearchBar() || showAnalysisSearchBar()) {
    <div class="spacer"></div>
  }
  <!--  <ng-content></ng-content>-->
  <div class="right-side-container" gnxRtl>
    @if (!auth0Store.isLoggedIn()) {
      <div class="more" [matMenuTriggerFor]="menu" (click)="learnMoreClicked()">
        <div class="red-dot" [class.invisible]="learnMoreDiscovered"></div>
        Learn More
        <div class="triangle"></div>
      </div>
    }
    @if (languageSelectorEnabled()) {
      <gnx-language-selector />
    }
    @if (auth0Store.isLoggedIn()) {
      <img src="assets/svg/support.svg" width="24" height="24" [matMenuTriggerFor]="menu" />
    }
    <mat-menu #menu="matMenu" class="drop-down-menu top-nav-menu">
      <button mat-menu-item (click)="goToHelpPage()">Help Center</button>
      @if (auth0Store.userDetails() && auth0Store.featureBits()?.[FeatureBit.Assets]) {
        <button mat-menu-item (click)="openContactSupportDialog()">Contact Support</button>
      }
      <button mat-menu-item (click)="goToReleaseUpdatesPage()">Release Updates</button>
      @if (showCommunityForum()) {
        <button mat-menu-item (click)="goToCommunityForum()">Community Forum</button>
      }
      <button mat-menu-item routerLink="/about">About Franklin</button>
      <button mat-menu-item routerLink="/citations">Publications</button>
      @if (environment.helpLinks?.regulatory) {
        <button mat-menu-item (click)="goToRegulatoryPage()">Product Info</button>
      }
    </mat-menu>
    @if (auth0Store.userDetails() && auth0Store.isLoggedIn()) {
      <div class="login-container">
        <div>
          <div
            class="user-name"
            gnxTextOverflowEllipsis
            #userNameOverflow="gnxTextOverflowEllipsis"
            [matTooltip]="userNameOverflow.isOverflowed ? (auth0Store.userDetails().name | titlecase) : ''"
            matTooltipPosition="below"
          >
            {{ auth0Store.userDetails().name | titlecase }}
          </div>
          <div class="community-name-container" [matMenuTriggerFor]="userMenu">
            <div
              class="community-name"
              gnxTextOverflowEllipsis
              #communityNameOverflow="gnxTextOverflowEllipsis"
              [matTooltip]="communityNameOverflow.isOverflowed ? auth0Store.userDetails().organization?.name : ''"
              matTooltipPosition="below"
            >
              {{ auth0Store.userDetails().organization?.name }}
            </div>
            <div class="triangle"></div>
          </div>
          <mat-menu #userMenu="matMenu" class="top-nav-menu">
            @if (auth0Store.userDetails().communities.length > 0) {
              <button mat-menu-item [matMenuTriggerFor]="communitiesMenu">My Communities</button>
            }
            @if (isAdmin()) {
              <button mat-menu-item [routerLink]="['/settings', 'members']">Invite Teammates</button>
            }
            @if (showAssets()) {
              <button mat-menu-item [routerLink]="['/clinical-db', 'assets']">Assets</button>
            }
            @if (auth0Store.featureBits()[FeatureBit.Discovery]) {
              <button mat-menu-item [routerLink]="['/clinical-db', 'discovery']">Discovery</button>
            }
            @if (auth0Store.userDetails().user_sigs.length > 0) {
              <button mat-menu-item [routerLink]="['/clinical-db', 'sig', auth0Store.userDetails().user_sigs[0]]">
                SIG
              </button>
            }
            <button mat-menu-item [routerLink]="['/settings']">Settings</button>
            @if (auth0Store.featureBits()[FeatureBit.CreditReport]) {
              <button mat-menu-item [routerLink]="['/credit-report']">Credit report</button>
            }
            @if (!environment.production) {
              <button mat-menu-item [matMenuTriggerFor]="fbsMenu">Feature bits</button>
            }
            <button mat-menu-item (click)="logout()">Log out</button>
          </mat-menu>
          <mat-menu #communitiesMenu="matMenu" class="top-nav-menu">
            @for (community of auth0Store.userDetails().communities; track community) {
              <button mat-menu-item>
                {{ community.name }}
              </button>
            }
          </mat-menu>
          <mat-menu #fbsMenu="matMenu" class="top-nav-menu">
            @let fbs = auth0Store.featureBits();
            @for (featureBit of Object.values(FeatureBit).sort(); track featureBit) {
              <button class="w-[400px]" mat-menu-item (click)="setFeatureBit(featureBit, !fbs[featureBit])">
                {{ featureBit }}: {{ fbs[featureBit] }}
              </button>
            }
          </mat-menu>
        </div>
      </div>
    }
    @if (!auth0Store.userDetails() || !auth0Store.isLoggedIn()) {
      <div class="sign-up-container">
        @if (!auth0Store.userDetails()) {
          <div class="icon-button" routerLink="/login" (click)="setRedirectAfterAuth()">Log In</div>
          @if (isSignupAllowed) {
            <button routerLink="/join" (click)="setRedirectAfterAuth()" class="border-button">Sign Up</button>
          }
        }
        @if (!!auth0Store.userDetails() && !auth0Store.isLoggedIn()) {
          <div class="icon-button" (click)="logout()">Log Out</div>
          <button
            routerLink="/post-join"
            [queryParams]="{ step: 1, midway: true }"
            class="border-button"
            (click)="setRedirectAfterAuth()"
          >
            Finish Sign Up
          </button>
        }
      </div>
    }
  </div>
</div>
